import {
  Typography,
  Box,
  Button,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useState } from "react";
import "./change_password.css";
import { useNavigate } from "react-router-dom";
import TextInput from "../../../components/TextInput/TextInput";
import { useForm } from "react-hook-form";
import getEventController from "../Controller/getEvent_controller";

//icon
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const ChangePassword = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const isLargeScreen = useMediaQuery("(min-width:640px)");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [error, setError] = useState(null);

  const toggleOldPasswordVisibility = () => {
    setShowOldPassword((prev) => !prev);
  };

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword((prev) => !prev);
  };

  const toggleConfirmNewPasswordVisibility = () => {
    setShowConfirmNewPassword((prev) => !prev);
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setError(null);

    // console.log(oldPassword);
    // console.log(newPassword);
    // console.log(confirmNewPassword);

    if (newPassword !== confirmNewPassword) {
      setError("New passwords do not match.");
      return;
    }

    const memberId = localStorage.getItem("memberId"); // Fetch the stored memberId
    const email = localStorage.getItem("email"); // Fetch the stored memberId
    const userId = localStorage.getItem("userId"); // Fetch the stored userId
    const response = await getEventController.updatePassword(
      userId,
      memberId,
      email,
      oldPassword,
      newPassword
    );

    console.log(memberId);
    console.log(email);

    if (response.success) {
      alert("Password updated successfully!");
      navigate("/profile"); // Redirect or provide feedback
    } else {
      alert(response.message || "Failed to update password.");
    }
  };

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
  } = useForm({
    defaultValues: {
      eventName: "",
      description: "",
      venue: "",
      poster: "",
      earlyBirdStartDate: "",
      earlyBirdEndDate: "",
      registrationStartDate: "",
      registrationEndDate: "",
      eventStartDateTime: "",
      eventEndDateTime: "",
      earlyBirdPrice: "",
      registrationPrice: "",
      numberOfPax: "",
      eventCategory: "",
    },
  });

  return (
    <React.Fragment>
      {!isLargeScreen ? (
        <div className="edit-password">
          <Box sx={{ display: "flex" }}>
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
              {/* <DrawerHeader /> */}
              {/* {showAlertSuccess && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {alertSuccessMsg}
            </Alert>
          )} */}

              <form>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Old Password</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>New Password</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Retype New Password</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                  </Grid>

                  <Box textAlign="center">
                    <Button
                      sx={{
                        borderRadius: "20px",
                        mt: 4,
                        mb: 4,
                        width: "100%",
                        height: "48px",
                        backgroundColor: "#d33333",
                        textTransform: "none",
                      }}
                      variant="contained"
                      type="submit"
                    >
                      <Typography variant="h6">Update Password</Typography>
                    </Button>
                  </Box>
                </Box>
              </form>
            </Box>
          </Box>
        </div>
      ) : (
        <div className="edit-password">
          <div>
            <ArrowBackIosIcon
              className="logo"
              onClick={() => navigate(-1)}
              label="BACK"
            />
            {/* <span>BACK </span> */}
          </div>
          <div className="change-password-title">
            <span>Change Password</span>
          </div>
          <Box sx={{ display: "flex" }}>
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
              {/* <DrawerHeader /> */}
              {/* {showAlertSuccess && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {alertSuccessMsg}
          </Alert>
        )} */}

              <form onSubmit={handleUpdatePassword}>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    {/* Old Password */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Old Password</label>
                      <div className="cp-input-row">
                        <input
                          name="old_password"
                          className="cp-input col-md-11"
                          type={showOldPassword ? "text" : "password"}
                          placeholder="Old Password"
                          required
                          value={oldPassword}
                          onChange={(e) => setOldPassword(e.target.value)}
                        />
                        <IconButton
                          className="col-md-1"
                          onClick={toggleOldPasswordVisibility}
                          sx={{
                            padding: 0,
                          }}
                        >
                          {showOldPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </div>
                    </Grid>
                    {/* New Password */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>New Password</label>
                      <div className="cp-input-row">
                        <input
                          name="new_password"
                          className="cp-input col-md-11"
                          type={showNewPassword ? "text" : "password"}
                          placeholder="New Password"
                          required
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <IconButton
                          className="col-md-1"
                          onClick={toggleNewPasswordVisibility}
                          sx={{
                            padding: 0,
                          }}
                        >
                          {showNewPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </div>
                    </Grid>
                    {/* Confirm New Password */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Confirm New Password</label>
                      <div className="cp-input-row">
                        <input
                          name="confirm_new_password"
                          className="cp-input col-md-11"
                          type={showConfirmNewPassword ? "text" : "password"}
                          placeholder="Confirm New Password"
                          required
                          value={confirmNewPassword}
                          onChange={(e) =>
                            setConfirmNewPassword(e.target.value)
                          }
                        />
                        <IconButton
                          className="col-md-1"
                          onClick={toggleConfirmNewPasswordVisibility}
                          sx={{
                            padding: 0,
                          }}
                        >
                          {showConfirmNewPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </div>
                    </Grid>
                  </Grid>

                  {error && <p className="error-message">{error}</p>}

                  <Box>
                    <Button
                      sx={{
                        borderRadius: "20px",
                        mt: 4,
                        mb: 4,
                        maxWidth: "800px",
                        width: "100%",
                        height: "48px",
                        backgroundColor: "#d33333",
                        textTransform: "none",
                      }}
                      variant="contained"
                      type="submit"
                    >
                      <Typography variant="h6">Update Password</Typography>
                    </Button>
                  </Box>
                </Box>
              </form>
            </Box>
          </Box>
        </div>
      )}
    </React.Fragment>
  );
};

export default ChangePassword;
